import {
	SET_FILTERED_AND_SORTED_SITE_MONITORINGS,
	SET_SITE_MONITORINGS,
	SET_CURRENT_SITE_MONITORING,
	SET_SITE_MONITORING_FILTERS,
	SET_FILTERED_AND_SORTED_NOTES,
	SET_ALL_TAGS,
	SET_EDITING_NOTE,
	SET_NOTES_FILTERS,
	SET_EXPANDED_LOT_ID,
	SET_LOTS,
	SET_NOTES,
	SET_PLANS,
	SET_EXPANDED_PLAN_ID,
	SET_NOTE_COMMENTS,
	SET_SITE_MONITORING_SELECTED_TAB,
	SET_NB_ALL_NOTES,
} from "./siteMonitoringConstants";
import { setValue } from "../../lib/immutable_wrapper";
import moment from "moment";
import { ALL_SELECT_OPTION } from "../../constants";
import { getDefaultNotesFilters } from "./noteActions";
moment.locale("fr");

const initialState = {
	siteMonitorings: [],
	filteredAndSortedSiteMonitorings: [],
	siteMonitoringsFilters: {
		siteNumber: "",
		city: "",
		customer: "",
		requireAction: false,
		status: [ALL_SELECT_OPTION],
	},
};

const siteMonitoringInitialState = {
	currentIntervention: null,
	expandedLotId: null,
	lots: [],
	plans: [],
	selectedTab: 0,
};

const notesInitialState = {
	filteredAndSortedNotes: [],
	editingNote: null,
	comments: [],
	notes: [],
	notesFilters: getDefaultNotesFilters(),
	nbAllNotes: 0,
};

const tagsInitialState = {
	allTags: [],
};

export function siteMonitorings(state = initialState, action) {
	switch (action.type) {
		case SET_SITE_MONITORINGS:
			return setValue(state, ["siteMonitorings"], action.siteMonitorings);
		case SET_FILTERED_AND_SORTED_SITE_MONITORINGS:
			return setValue(
				state,
				["filteredAndSortedSiteMonitorings"],
				action.siteMonitorings
			);
		case SET_SITE_MONITORING_FILTERS:
			return setValue(state, ["siteMonitoringsFilters"], action.filters);
		default:
			return state;
	}
}

export function siteMonitoring(state = siteMonitoringInitialState, action) {
	switch (action.type) {
		case SET_CURRENT_SITE_MONITORING:
			return setValue(
				state,
				["currentSiteMonitoring"],
				action.currentSiteMonitoring
			);
		case SET_EXPANDED_LOT_ID:
			return setValue(state, ["expandedLotId"], action.expandedLotId);
		case SET_LOTS:
			return setValue(state, ["lots"], action.lots);
		case SET_EXPANDED_PLAN_ID:
			return setValue(state, ["expandedPlanId"], action.expandedPlanId);
		case SET_PLANS:
			return setValue(state, ["plans"], action.plans);
		case SET_SITE_MONITORING_SELECTED_TAB:
			return setValue(state, ["selectedTab"], action.selectedTab);
		default:
			return state;
	}
}

export function notes(state = notesInitialState, action) {
	switch (action.type) {
		case SET_NOTES:
			return setValue(state, ["notes"], action.notes);
		case SET_FILTERED_AND_SORTED_NOTES:
			return setValue(
				state,
				["filteredAndSortedNotes"],
				action.filteredAndSortedNotes
			);
		case SET_EDITING_NOTE:
			return setValue(state, ["editingNote"], action.editingNote);
		case SET_NOTES_FILTERS:
			return setValue(state, ["notesFilters"], action.filters);
		case SET_NOTE_COMMENTS:
			return setValue(state, ["comments"], action.comments);
		case SET_NB_ALL_NOTES:
			return setValue(state, ['nbAllNotes'], action.nbAllNotes);
		default:
			return state;
	}
}

export function tags(state = tagsInitialState, action) {
	switch (action.type) {
		case SET_ALL_TAGS:
			return setValue(state, ["allTags"], action.allTags);
		default:
			return state;
	}
}
